import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material"; // Assuming you're using Material-UI

const RichContentInfo = ({ content, index, scrollToBottom }) => {
  useEffect(() => {
    if (scrollToBottom) {
      scrollToBottom();
    }
  }, []);

  return (
    <Box
      key={index}
      sx={{
        width: "100%",
        marginBottom: "0%",
        marginTop: "10px",
      }}
    >
      <a
        href={content.actionLink}
        target="_blank"
        rel="noopener noreferrer" // Added for security
      >
        <img
          width="100%"
          style={{ maxWidth: "400px" }}
          height={content.height}
          src={content.image?.src?.rawUrl}
          alt={content.title || "Rich content image"} // Added accessibility
        />
      </a>
      <Typography
        sx={{
          fontFamily: "Google Sans",
          fontWeight: "bold",
          fontSize: "24px",
          color: "white",
        }}
      >
        {content.title}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Google Sans",
          fontSize: "20px",
          color: "white",
        }}
      >
        {content.subtitle}
      </Typography>
    </Box>
  );
};

export default RichContentInfo;

// Usage example:
/*
<RichContentInfo
  index={0}
  content={{
    type: 'info',
    actionLink: 'https://example.com',
    height: '200px',
    image: {
      src: {
        rawUrl: 'https://example.com/image.jpg'
      }
    },
    title: 'Example Title',
    subtitle: 'Example Subtitle'
  }}
/>
*/
